require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./places-de-parking-1-0-2.json") })
        }
      }, "path---places-de-parking-1-0-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---places-de-parking-1-0-2!./.cache/json/places-de-parking-1-0-2.json
// module id = 523
// module chunks = 231608221292675